import { Form } from "antd";
import { useTranslation } from "react-i18next";
import Style from "./style";
import Text from "../Inputs/Text";
import Phone from "../Inputs/Phone";
import Select from "../Inputs/Select";
import Switch from "../Inputs/Switch";
import { INPUT_TYPES } from "../../../config";
import ImageUpload from "../Inputs/ImageUpload";
import ResetPassword from "../Inputs/ResetPassword";
import TransferRights from "../Inputs/TransferRights";

export default function EditForm({
  activeForm = {},
  onChange = {},
  data = {},
  setInputLoading = () => { },
  inputLoading,
}) {
  const { t } = useTranslation();

  const config = {
    setLoading: setInputLoading,
    loading: inputLoading,
  };

  const renderInput = (input = {}) => {
    if (input.type === INPUT_TYPES.RESET_PASSWORD) {
      if (input.disabled) {
        return null;
      }

      return <ResetPassword config={config} />;
    }

    if (input.type === INPUT_TYPES.TRANSFER_RIGHTS) {
      return <TransferRights input={input} />;
    }

    if (input.type === INPUT_TYPES.SWITCH) {
      return (
        <Form.Item key={input.key}>
          <Switch data={data} input={input} onChange={onChange} />
        </Form.Item>
      )
    }

    if (input.type === INPUT_TYPES.INPUT_GROUP) {
      return (
        <div className="input-group" key={input.key}>
          {(input.inputs).map(renderInput)}
        </div>
      )
    }

    const _renderInput = () => {
      switch (input.type) {
        case INPUT_TYPES.IMAGE_UPLOAD:
          return <ImageUpload data={data} input={input} onChange={onChange} config={config} />;
        case INPUT_TYPES.TEXT:
          return <Text data={data} input={input} onChange={onChange} />;
        case INPUT_TYPES.SELECT:
          return <Select data={data} input={input} onChange={onChange} />;
        case INPUT_TYPES.PHONE:
          return <Phone data={data} input={input} onChange={onChange} />;
        default:
          return null;
      }
    }

    return (
      <Form.Item label={input.label} key={input.key}>{_renderInput()}</Form.Item>
    )
  }

  return (
    <Form
      autoComplete="new-password"
      layout="vertical"
      className="main-form"
    >
      <Style>
        {(activeForm?.inputGroups || []).map((gr, i) => (
          <div key={`form-gr-${i}`} className="form-gr">
            <div className="group-header">
              {gr.title ? (
                <h3>{t(gr.title)}</h3>
              ) : null}
              <p>{t(gr.subTitle)}</p>
            </div>
            {(gr.inputs || [])
              .filter((i) => {
                if (typeof i.showIf === 'function') {
                  return i.showIf(data);
                }

                return true;
              })
              .map(renderInput)}
          </div>
        ))}
      </Style>
    </Form>
  )
}
